// extracted by mini-css-extract-plugin
module.exports = {"section":"Filters_section__3Gi-Q"};